import { PROFILE_CACHE_KEY } from "./storageKeys";

// The last-seen profile of the signed-in account, kept on this device so the
// Profile page and the navbar avatar can paint the real name, photo and
// counts straight away on the next visit instead of waiting a network round
// trip, then get corrected by the fresh fetch. Keyed by account id so it can
// never show one account's details to another, and wiped on logout
// (clearLocalUserData).
export function readProfileCache(userId) {
  if (!userId) return null;
  try {
    const raw = localStorage.getItem(PROFILE_CACHE_KEY);
    const parsed = raw ? JSON.parse(raw) : null;
    return parsed && parsed.userId === userId ? parsed.data : null;
  } catch {
    return null;
  }
}

export function mergeProfileCache(userId, partial) {
  if (!userId) return;
  try {
    const data = { ...(readProfileCache(userId) || {}), ...partial };
    localStorage.setItem(PROFILE_CACHE_KEY, JSON.stringify({ userId, data }));
  } catch {
    // storage full or blocked — the cache just won't be there next time
  }
}
